import { useTranslation } from "react-i18next";

import Logo from "../Logo";

import "./styles.scss";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  // Local dev aid: shows what each tier is running, set by ticket-env.sh — the UI's own
  // label via REACT_APP_TICKET and the backend's via REACT_APP_TICKET_BE. Each label is
  // the ticket when that tier runs from its worktree, or the branch name when it runs
  // from the main checkout. Collapsed to a single label when both match. Never rendered
  // in production, where the vars are unset.
  const uiLabel = process.env.REACT_APP_TICKET;
  const beLabel = process.env.REACT_APP_TICKET_BE;
  let ticketBadge = null;
  if (uiLabel && beLabel) {
    ticketBadge = uiLabel === beLabel ? uiLabel : `BE: ${beLabel} · UI: ${uiLabel}`;
  } else {
    ticketBadge = uiLabel || beLabel || null;
  }

  return (
    <div className="footer">
      <div className="footer-left">
        <span className="footer-text">{t("footer.system_engineered_by")}</span>
        <a href="/" className="logo-link">
          <Logo />
        </a>
      </div>
      {ticketBadge && <span className="footer-ticket">🎫 {ticketBadge}</span>}
      <span className="footer-text">© {currentYear}</span>
    </div>
  );
};

export default Footer;
